import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

export function Navigation({ onScrollTo, onAdminClick, onHomeClick }) {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const handleScroll = (id) => {
        onScrollTo?.(id);
        setMobileMenuOpen(false);
    };

    const handleAdminClick = (e) => {
        e.preventDefault();
        onAdminClick?.();
        setMobileMenuOpen(false);
    };

    const handleHomeClick = () => {
        onHomeClick?.();
        setMobileMenuOpen(false);
    };

    return (
        <nav className="sticky top-0 z-50 bg-[#fdfbf7]/95 backdrop-blur-md border-b border-[#eaddcf]">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
                <div className="flex justify-between items-center">
                    <div
                        className="text-xl sm:text-2xl font-serif text-[#c5a059] tracking-widest font-semibold cursor-pointer"
                        onClick={handleHomeClick}
                    >
                        FABIHA ZAMAN
                    </div>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex space-x-6 lg:space-x-8 text-gray-600 font-medium text-sm tracking-wide items-center">
                        <button onClick={() => handleScroll('about')} className="hover:text-[#d48c95] transition py-2">About</button>
                        <button onClick={() => handleScroll('programme')} className="hover:text-[#d48c95] transition py-2">Coaching</button>
                        <button onClick={() => handleScroll('freebie')} className="hover:text-[#d48c95] transition py-2">Free Meditation</button>
                        <button onClick={() => handleScroll('booking')} className="px-5 py-2.5 bg-[#d48c95] text-white rounded-full hover:bg-[#c07b83] transition shadow-md min-h-[44px]">
                            Book Now
                        </button>
                        <a
                            href="#admin"
                            onClick={handleAdminClick}
                            className="text-xs text-gray-400 hover:text-gray-600 transition"
                            title="Admin"
                        >
                            Admin
                        </a>
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        className="md:hidden p-2 text-gray-600 hover:text-[#d48c95] transition min-h-[44px] min-w-[44px] flex items-center justify-center"
                        aria-label="Toggle menu"
                    >
                        {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>

                {/* Mobile Menu */}
                {mobileMenuOpen && (
                    <div className="md:hidden mt-4 pb-4 border-t border-[#eaddcf] pt-4 animate-slideDown">
                        <div className="flex flex-col space-y-3">
                            <button
                                onClick={() => handleScroll('about')}
                                className="text-left px-4 py-3 text-gray-600 hover:text-[#d48c95] hover:bg-[#fae1e5]/30 rounded-lg transition font-medium min-h-[48px] flex items-center"
                            >
                                About
                            </button>
                            <button
                                onClick={() => handleScroll('programme')}
                                className="text-left px-4 py-3 text-gray-600 hover:text-[#d48c95] hover:bg-[#fae1e5]/30 rounded-lg transition font-medium min-h-[48px] flex items-center"
                            >
                                Coaching
                            </button>
                            <button
                                onClick={() => handleScroll('freebie')}
                                className="text-left px-4 py-3 text-gray-600 hover:text-[#d48c95] hover:bg-[#fae1e5]/30 rounded-lg transition font-medium min-h-[48px] flex items-center"
                            >
                                Free Meditation
                            </button>
                            <button
                                onClick={() => handleScroll('booking')}
                                className="mx-4 px-5 py-3.5 bg-[#d48c95] text-white rounded-full hover:bg-[#c07b83] transition shadow-md font-medium min-h-[48px] flex items-center justify-center"
                            >
                                Book Now
                            </button>
                            <a
                                href="#admin"
                                onClick={handleAdminClick}
                                className="text-left px-4 py-3 text-xs text-gray-400 hover:text-gray-600 transition min-h-[44px] flex items-center"
                            >
                                Admin
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </nav>
    );
}

export default Navigation;
